//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            groups: [
                [
                    {
                        image: 'dragdrop_1_1.png',
                        x: 311,
                        y: 632,
                        width: 60,
                        height: 72,
                        dropArea: { xMin: 627, xMax: 687, yMin: 517, yMax: 589 }
                    },
                    {
                        image: 'dragdrop_1_2.png',
                        x: 333,
                        y: 467,
                        width: 28,
                        height: 42,
                        dropArea: { xMin: 643, xMax: 671, yMin: 575, yMax: 617 }
                    },
                    {
                        image: 'dragdrop_1_3.png',
                        x: 101,
                        y: 564,
                        width: 47,
                        height: 188,
                        dropArea: { xMin: 627, xMax: 674, yMin: 608, yMax: 796 }
                    }
                ],
                [
                    {
                        image: 'dragdrop_2_1.png',
                        x: 387,
                        y: 554,
                        width: 74,
                        height: 102,
                        dropArea: { xMin: 874, xMax: 948, yMin: 516, yMax: 618 }
                    },
                    {
                        image: 'dragdrop_2_2.png',
                        x: 378,
                        y: 423,
                        width: 34,
                        height: 42,
                        dropArea: { xMin: 894, xMax: 928, yMin: 605, yMax: 647 }
                    },
                    {
                        image: 'dragdrop_2_3.png',
                        x: 88,
                        y: 390,
                        width: 47,
                        height: 159,
                        dropArea: { xMin: 891, xMax: 938, yMin: 636, yMax: 795 }
                    }
                ],
                [
                    {
                        image: 'dragdrop_3_1.png',
                        x: 281,
                        y: 544,
                        width: 55,
                        height: 67,
                        dropArea: { xMin: 1070, xMax: 1125, yMin: 532, yMax: 599 }
                    },
                    {
                        image: 'dragdrop_3_2.png',
                        x: 319,
                        y: 381,
                        width: 25,
                        height: 39,
                        dropArea: { xMin: 1084, xMax: 1109, yMin: 587, yMax: 626 }
                    },
                    {
                        image: 'dragdrop_3_3.png',
                        x: 165,
                        y: 453,
                        width: 47,
                        height: 179,
                        dropArea: { xMin: 1077, xMax: 1124, yMin: 617, yMax: 796 }
                    }
                ]
            ]
        };
    },

    computed: {
        result () {
            let stars = this.groups.filter(puzzles => !puzzles.some(puzzle => !puzzle.inDropArea)).length;
            let wrong = this.groups.reduce((acc, puzzles) => acc + puzzles.filter(puzzle => !puzzle.inDropArea).length, 0);
            let correct = this.groups.reduce((acc, puzzles) => acc + puzzles.filter(puzzle => puzzle.inDropArea).length, 0);

            return {
                stars,
                wrong,
                correct
            };
        }
    },

    created () {
        this.groups.forEach((puzzles, index) => {
            puzzles.forEach((puzzle, index) => {
                this.$set(puzzle, 'inDropArea', false);
                this.$set(puzzle, 'zIndex', 4);
            });
        });
    },

    methods: {
        dragend (puzzle, { x, y }) {
            puzzle.zIndex--;
            puzzle.x = x;
            puzzle.y = y;

            puzzle.inDropArea = puzzle.x >= puzzle.dropArea.xMin - puzzle.width / 2 &&
                puzzle.x <= puzzle.dropArea.xMax - puzzle.width / 2 &&
                puzzle.y >= puzzle.dropArea.yMin - puzzle.height / 2 &&
                puzzle.y <= puzzle.dropArea.yMax - puzzle.height / 2;

            if (puzzle.inDropArea) {
                this.$nextTick(() => {
                    puzzle.x = puzzle.dropArea.xMin;
                    puzzle.y = puzzle.dropArea.yMin;
                });
            }
        }
    }
};
